module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external "angular-ui-bootstrap"
// module id = 23
// module chunks = 0